import { Box, Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import Button from "../components/commons/Button";
import Head from "../components/commons/Head";
import Fanfaron from "../components/fanfarons/Fanfaron";
import FanfaronDialog from "../components/fanfarons/FanfaronDialog";
import { IFanfaron } from "../models/IFanfaron";
import { IWording } from "../models/IWording";

const fanfaronsWordings: IWording = require("../assets/configuration/wordings/fanfarons.json");
const fanfaronsDatabase: IFanfaron[] = require("../assets/configuration/database/fanfarons.json");

const FanfaronsView = () => {

    const {id} = useParams();

    const [fanfarons, setFanfarons] = useState([] as IFanfaron[]);
    const [fanfaron, setFanfaron] = useState({} as IFanfaron);
    const [category, setCategory] = useState(undefined as string | undefined);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        setFanfarons(shuffleFanfarons());

        if (id) {
            const f = filterFanfaronByNickname(id);
            if (f.nickname) openDialog(f);
        }
    }, [id]);

    const shuffleFanfarons = () => fanfaronsDatabase.slice().sort(() => 0.5 - Math.random());

    const openDialog = (fanfaron: IFanfaron) => {
        setFanfaron(fanfaron);
        setOpen(true);
    }

    const momo = () => openDialog(filterFanfaronByNickname('momo'));
    const randomFanfaron = () => openDialog(fanfaronsDatabase[Math.floor(Math.random() * fanfaronsDatabase.length)]);

    const filterFanfaronByNickname = (nickname: string): IFanfaron => {
        const filteredFanfaron = fanfaronsDatabase.filter(f => f.nickname.toLowerCase() === nickname.toLowerCase());
        return filteredFanfaron.length > 0 ? filteredFanfaron[0] : {} as IFanfaron;
    }

    const filterFanfaronsByCategory = (c: string) => {
        
        if (category === c) {
            setCategory(undefined);
            setFanfarons(shuffleFanfarons());
        } else {
            setCategory(c);
            setFanfarons(shuffleFanfarons().filter(f => f.category === c));
        }   
    }

    const handleClose = () => setOpen(false);

    return <>
        <Head title={fanfaronsWordings.title} description={fanfaronsWordings.description}/>

        <Box sx={{display: 'flex', marginTop: '30px'}}>
            <Button label={'👑 Momo'} onClick={() => momo()}/>
            <Button label={'🔀 Aléatoire'} onClick={() => randomFanfaron()}/>
        </Box>

        <Box sx={{display: 'flex'}}>
            <Button label={'🎧 Aigus'} onClick={() => filterFanfaronsByCategory("AIGU")} press={category === "AIGU"}/>
            <Button label={'🎷 Petits saxs'} onClick={() => filterFanfaronsByCategory("PETIT_SAX")} press={category === "PETIT_SAX"}/>
            <Button label={'🎷🎷 Gros saxs'} onClick={() => filterFanfaronsByCategory("GROS_SAX")} press={category === "GROS_SAX"}/>
            <Button label={'🎺 Trompettes'} onClick={() => filterFanfaronsByCategory("TROMPETTE")} press={category === "TROMPETTE"}/>
            <Button label={'🎺🎺 Trombones'} onClick={() => filterFanfaronsByCategory("TROMBONE")} press={category === "TROMBONE"}/>
            <Button label={'🎺🎺🎺 Tubas'} onClick={() => filterFanfaronsByCategory("TUBA")} press={category === "TUBA"}/>
            <Button label={'🎺🎺🎺🎺 Soubas'} onClick={() => filterFanfaronsByCategory("SOUBA")} press={category === "SOUBA"}/>
            <Button label={'🥁 Percus'} onClick={() => filterFanfaronsByCategory("PERCU")} press={category === "PERCU"}/>
        </Box>

        <Grid container spacing={2} sx={{marginTop: '30px'}}>
            {fanfarons.map(f =>
                <Grid item key={f.nickname} xs={6} md={4} lg={2} xl={2}>
                    <Fanfaron fanfaron={f} openDialog={openDialog}/>
                </Grid>)
            }
        </Grid>

        {open && <FanfaronDialog fanfaron={fanfaron} open={open} onClose={handleClose} momo={momo} randomFanfaron={randomFanfaron}/>}
    </>
}

export default FanfaronsView;